<template>
  <div class="empty-state text-center text-secondary py-5">
    <i :class="['bi', icon, 'empty-icon']"></i>
    <h5 class="mt-3 mb-1">{{ title }}</h5>
    <p v-if="message" class="mb-3">{{ message }}</p>
    <slot />
  </div>
</template>

<script lang="ts">
export default {
  name: "EmptyState",
  props: {
    icon: {
      type: String,
      default: "bi-inbox",
    },
    title: {
      type: String,
      default: "هنوز چیزی اینجا نیست",
    },
    message: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.empty-icon {
  font-size: 2.5rem;
  opacity: 0.5;
}
</style>
